module.exports = __webpack_public_path__ + "media/entities/3008-f0eb6d22.png";